const url = location.pathname;

if (url.indexOf('confirm') != -1) {
  const textHide = document.querySelector('.js-hide');
  textHide.style.display = 'none';
}
